import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createJazelVuetify } from '@jazel/jazel-vuetify'

export default createJazelVuetify({
  appClass: 'jzl-admin',
})
